import React, {useEffect, useRef, useState} from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import BSModal from 'react-bootstrap/Modal';
import {getDeviceCtls, getDeviceType, getFirmwareList, postDeviceCtl} from "../../api/apiClient";
import {Col, Row} from "react-bootstrap";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';

// 제어 모달

const ModalCtrl = ({
                       propShow = false,
                       propDevice,
                       propType = '1', // 1게이트 2중계기 3센서
                       propSensorType = '', // 1화재 2움직임 3벨
                       setShow,
                   }) => {

    const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    /* 제어 명령 목록 */
    const [ctlList, setCtlList] = useState([]);

    /* 제어 명령 목록 갱신 */
    const updateCtlList = () => {
        getDeviceCtls(propType)
            .then((res) => {
                    if (res.data.data !== undefined) {
                        setCtlList(filteredCtlList(res.data.data.list));
                    }
                }
            )
            .catch((err) => {
                Swal.fire(
                    err.response.data.message,
                    '',
                    'error'
                );
            })
    };

    const filteredCtlList = (list) => {
        let fList = [];
        console.log('갱신')
        if (propType == '3' && propSensorType == '1') {
            //화재
            for (let i = 0; i < list.length; i++) {
                if (list[i].cd != '303') {
                    fList.push(list[i]);
                }
            }
        } else if (propType == '3' && propSensorType == '2') {
            //움직임
            for (let i = 0; i < list.length; i++) {
                if (list[i].cd != '302') {
                    fList.push(list[i]);
                }
            }
        } else if (propType == '3' && propSensorType == '3') {
            //벨
            for (let i = 0; i < list.length; i++) {
                if (list[i].cd != '302' &&
                    list[i].cd != '303'
                ) {
                    fList.push(list[i]);
                }
            }
        } else {
            for (let i = 0; i < list.length; i++) {
                fList.push(list[i]);
            }

        }

        return fList;
    }

    // 팝업 노출 시 제어 명령 목록 갱신
    useEffect(() => {
        updateCtlList();
        updateDeviceType();
        updateFirmwareList();
    }, [propType, propSensorType]);

    const onChangeCtlType = (e) => {
        e.preventDefault();
        if (e.target.selectedIndex != '0') {
            const names = e.target[e.target.selectedIndex].dataset.item.split('|');
            const opts = e.target[e.target.selectedIndex].dataset.opt.split('|');
            const drc = e.target[e.target.selectedIndex].dataset.drc

            let items = []
            for (let i = 0; i < names.length; i++) {
                let type = 'combo'
                if (opts[i] == '' || opts[i] == undefined) {
                    type = 'input'
                }
                let opt = opts[i].split(',');
                for (let j = 0; j < opt.length; j++) {
                    const cd_name = opt[j].split('^');
                    if (cd_name.length == 1) {
                        opt[j] = {cd: cd_name[0], name: cd_name[0]}
                    } else {
                        opt[j] = {cd: cd_name[0], name: cd_name[1]}
                    }
                }
                if (names[i] != '')
                    items.push({name: names[i], type: type, opt: opt})
            }
            // console.log(items);

            setCtlType((prevState) => {
                return {...prevState, cd: e.target.value, item: items, drc: drc};
            });
        } else {
            setCtlType((prevState) => {
                return {...prevState, cd: '0', item: []};
            });
        }
    };

    const onChangeDeviceType = (e) => {
        setFirmSubmit({
            ...stFirmSubmit,
            paramtr1: e.target.value,
            paramtr2: 0,
            paramtr3: 0,
            ver: -1
        });
        refSize.current = '';
    }


    const [ctlType, setCtlType] = useState({
        cd: '',
        item: [],
    });

    useEffect(() => {
        console.log(ctlType);
        if (ctlType.cd == '101' ||
            ctlType.cd == '201') {
            setSubmit({deviceID: propDevice, ctrlTy: ctlType.cd, paramtr1: '3600'});
        } else {
            setSubmit({deviceID: propDevice, ctrlTy: ctlType.cd});
        }
    }, [ctlType]);

    useEffect( () => {
        setSubmit({...stSubmit, deviceID: propDevice});
        setFirmSubmit({...stFirmSubmit, deviceID: propDevice});
    }, [propDevice])


    // getDeviceType

    // getFirmwareList
    const refSize = useRef();
    const [stFirmList, setFirmList] = useState([]);
    const [stFirmSubmit, setFirmSubmit] = useState({
        deviceID: propDevice,
        ctrlTy: '306', // only firmware
        paramtr1: propType, // only gateway
        paramtr2: 0,
        paramtr3: 0,
    })

    useEffect(() => {
        updateFirmwareList();
    }, [stFirmSubmit]);


    const updateFirmwareList = () => {
        getFirmwareList(stFirmSubmit.paramtr1)
            .then(res => {
                setFirmList(res.data.data.list);
            })
            .catch(err => {
                Swal.fire(
                    err.response.data.message,
                    '',
                    'error'
                );
            });
    };

    const onChangeFirmVersion = (e) => {
        let idx = e.target.value
        if (idx !== -1) {
            refSize.current = stFirmList[idx].file_sz;
            console.log(stFirmList[idx].file_sz)
            console.log(refSize);
            setFirmSubmit({
                ...stFirmSubmit, deviceID: propDevice,
                paramtr2: stFirmList[idx].fw_ver, paramtr3: stFirmList[idx].file_sz,
                ver: idx
            })
        } else {
            refSize.current = '0'
        }
    };

    /* 공통코드 목록 */
    const [deviceType, setDeviceType] = useState([]);

    /* 공통코드 목록 갱신 */
    const updateDeviceType = () => {
        getDeviceType()
            .then((res) => {
                if (res.data.data !== undefined) {
                    setDeviceType(res.data.data.list);
                }
            })
            .catch(err => {
                Swal.fire(
                    err.response.data.message,
                    '',
                    'error'
                );
            });
    };

    const [stSubmit, setSubmit] = useState([]);
    useEffect(() => {
        console.log(stSubmit);
    }, [stSubmit])

    const onChangeParam = (e, idx) => {
        console.log(e.target.value, idx);
        let submit = stSubmit
        submit[`paramtr${idx + 1}`] = e.target.value;
        setSubmit(submit);

        console.log(submit)

        // let param = [stSubmit.paramtr1, stSubmit.paramtr2, stSubmit.paramtr3]
        // param[idx] = e.target.value
        // setSubmit({...stSubmit, paramtr1: param[0], paramtr2: param[1], paramtr3: param[3]});
    }

    const isValidate = (stData, length) => {

        // console.log('Validate!!!');
        // console.log(stData);
        // console.log(length);

        // 서버에서 validation.

        return true;
    }

    const onSubmit = (e) => {
        // console.log(ctlType)
        if (ctlType.cd === '306') {
            if (isValidate(stFirmSubmit)) {
                postDeviceCtl(stFirmSubmit)
                    .then(res => {
                        if (ctlType.drc != 'O') {
                            handleClose();
                        }
                        Swal.fire(
                            '정상적으로 처리 되었습니다!',
                            '',
                            'success'
                        );
                    })
                    .catch(err => {
                        Swal.fire(
                            err.response?.data?.message ? err.response.data.message :
                                '반드시 파라미터 값이 필요합니다.',
                            '',
                            'error'
                        );
                    });
            }
            else {
                Swal.fire(
                    '반드시 파라미터 값이 필요합니다.',
                    '',
                    'error'
                );
            }
        } else {
            if (isValidate(stSubmit, ctlType.item.length)) {
            postDeviceCtl(stSubmit, ctlType.item.length)
                .then(res => {
                    console.log(res);
                    if (ctlType.drc != 'O') {
                        handleClose();
                    }
                    Swal.fire(
                        '정상적으로 처리 되었습니다!',
                        '',
                        'success'
                    );
                })
                .catch(err => {
                    Swal.fire(
                        err.response?.data?.message ? err.response.data.message :
                            '반드시 파라미터 값이 필요합니다.',
                        '',
                        'error'
                    );
                });
            }
            else {
                Swal.fire(
                    '반드시 파라미터 값이 필요합니다.',
                    '',
                    'error'
                );
            }
        }
    };

    const CtrlBody = ({propType}) => {
        // drc, item 파서 만들어서 고쳐야 함.
        // 그래도 어차피 펌웨어는 case 갈라야 함. (opt 형태를 api로 던져놓기만 했으니 처리 불가)
        // 만들다만 프로토콜에 예쁘게 동작하게 하기는 어렵고,
        // 확실하게 동작하게 하기 위해서 CD로 전부 하드코딩;

        // 306은 예외
        if (propType === '306')
            return (<>
                <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                    <Form.Label column md={4} className={'label text-end fw-bold'}>
                        {/* 펌웨어타입 */}
                        <span className={"text-danger"}>* </span>{ctlType.item[0].name}
                    </Form.Label>
                    <Col md={8} className={''}>
                        <Form.Select
                            aria-label="Default select example"
                            className={"input input-select"}
                            onChange={onChangeDeviceType}
                            value={stFirmSubmit[`paramtr${1}`]}
                        >
                            <option value={'-1'}>선택하세요.</option>
                            {Array.isArray(deviceType) ?
                                (deviceType.map((elem, idx) => {
                                    return (
                                        <option key={idx} value={elem.cd} data-item={elem.item}>{elem.nm}</option>
                                    )
                                })) : ''}
                        </Form.Select>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                    <Form.Label column md={4} className={'label text-end fw-bold'}>
                        {/* 펌웨어버전 */}
                        <span className={"text-danger"}>* </span>{ctlType.item[1].name}
                    </Form.Label>
                    <Col md={8} className={''}>
                        <Form.Select
                            aria-label="Default select example"
                            className={"input input-select"}
                            onChange={onChangeFirmVersion}
                            value={stFirmSubmit[`ver`]}
                        >
                            <option value={'-1'}>선택하세요.</option>
                            {Array.isArray(stFirmList) ?
                                (stFirmList.map((elem, idx) => {
                                    return (
                                        <option key={idx} value={idx}>{elem.fw_ver}</option>
                                    )
                                })) : ''}

                        </Form.Select>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formGtwyId" className={"mt-3"}>
                    <Form.Label column md={4} className={'label text-end fw-bold'}>
                        {/* 파일 사이즈 */}
                        <span className={"text-danger"}>* </span>{ctlType.item[2].name}
                    </Form.Label>
                    <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            readOnly={true}
                            value={refSize.current}
                        />
                    </Col>
                </Form.Group>

            </>)

        else
            return (<>
                {ctlType.item.map((item, idx) => {
                    return (
                        <Form.Group as={Row} controlId="formItem" className={"mt-3"} key={idx}>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>{item.name}
                            </Form.Label>
                            <Col md={8}>
                                {item.type === 'input' ?
                                    <Form.Control
                                        type='text'
                                        className={'input'}
                                        value={stSubmit[`paramtr${idx + 1}`]}
                                        onChange={event => {
                                            onChangeParam(event, idx)
                                        }}
                                    /> :
                                    <Form.Select
                                        aria-label={"control select" + idx}
                                        className={"input input-select"}
                                        onChange={event => {
                                            onChangeParam(event, idx)
                                        }}
                                        value={stSubmit[`paramtr${idx + 1}`]}
                                    >
                                        <option value={'-1'}>선택</option>
                                        {item.opt.map((opt, index) => {
                                            return (
                                                <option key={index} value={opt.cd}>{opt.name}</option>
                                            )
                                        })}
                                    </Form.Select>
                                }
                            </Col>
                        </Form.Group>
                    )
                })}
                {ctlType.drc == 'O' ?
                    <Form.Group as={Row} controlId="formOut" className={"mt-3"}>
                        <Form.Label column md={4} className={'label text-end fw-bold'}>
                            <span className={"text-danger"}>* </span>출력
                        </Form.Label>
                        <Col md={8}>
                            <Form.Control
                                as="textarea"
                                style={{height: '100px'}}
                                className={'input'}
                                // defaultValue={0}
                                // onChange={event => {onChangeParam(event, idx)}}
                            />
                        </Col>
                    </Form.Group>
                    : ''}
            </>)
    };

    return (
        <>
            <BSModal
                show={propShow}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="lg"
            >
                <BSModal.Header closeButton closeVariant={"white"}>
                    <BSModal.Title>
                        {propType == "1" ? '게이트웨이 제어' : ''}
                        {propType == "2" ? '중계기 제어' : ''}
                        {propType == "3" ?
                            propSensorType == '1' ? '무선화재감지기 제어' :
                                propSensorType == '2' ? '움직임감지기 제어' :
                                    propSensorType == '3' ? '무선비상벨 제어' :
                                        `알수없는 ${propSensorType} 센서 제어` : ''
                        }
                    </BSModal.Title>
                </BSModal.Header>
                <BSModal.Body>

                    <Row className={"layer"}>
                        <Col className={''}>
                            <Row className={'info-container py-2 mx-3'}>
                                <Col md={10}>
                                    <div className={'content-container-body-item'}>
                                        <Form>
                                            <Form.Group as={Row} controlId="formJurisdictionSelect">
                                                <Form.Label column md={4} className={"label text-end fw-bold"}>
                                                    <span className={"text-danger"}>* </span>제어명령
                                                </Form.Label>
                                                <Col md={8}>
                                                    <Form.Select
                                                        aria-label="Default select example"
                                                        className={"input input-select"}
                                                        onChange={onChangeCtlType}
                                                        defaultValue={ctlType.cd}
                                                    >
                                                        <option value={""}>제어명령 선택</option>
                                                        {Array.isArray(ctlList) ?
                                                            (ctlList.map((elem, idx) => {
                                                                return (
                                                                    <option key={idx} value={elem.cd}
                                                                            data-item={elem.item}
                                                                            data-opt={elem.opt}
                                                                            data-drc={elem.drc}>
                                                                        {elem.nm}</option>
                                                                )
                                                            })) : ''}
                                                    </Form.Select>
                                                </Col>
                                            </Form.Group>
                                            <CtrlBody
                                                propType={ctlType.cd}
                                            />
                                        </Form>
                                    </div>
                                </Col>
                            </Row>

                            <Row className={"my-3 justify-content-center"}>
                                <Col md={2} className={'text-center'}>
                                    <Button onClick={onSubmit} className={'btn save-btn w-100'}>실행</Button>
                                </Col>
                                <Col md={2} className={'text-center'}>
                                    <Button className={'btn btn-secondary w-100'} onClick={handleClose}>취소</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </BSModal.Body>
            </BSModal>
        </>
    );
}

export default ModalCtrl;
